import request from '@app/utils/apiRequest';
import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {Messages} from "@app/constants/Messages";

export const requestSaveEmployee = (data) => request.post(`employee/save`, data)


export const requestGetEmployeeList = (params) => request.get(`employee/list`, {params: params});
export const requestGetEmployee = (params) => request.get(`employee/detail`, {params: params});
